import React from "react";
import Home from "src/components/feature/Home";

const RegisteredLands = () => {
  return <Home registrationType={"registeredLands"} />;
};

export default RegisteredLands;
